import axios from "axios";
const MEDECIN_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/admin/healthPro";
const SEARCHE_API_BASE_URL = "https://doclicapp.herokuapp.com/api/admin/filter";
class ServiceMedecin {
  getMedecin() {
    return axios.get(MEDECIN_API_BASE_URL);
  }

  searchMedecin(medecin, ville) {
    return axios.post(SEARCHE_API_BASE_URL, {
      medecin,
      ville,
    });
  }
}

export default new ServiceMedecin();
